import { makeStyles } from '@material-ui/core';

var useButtonStyles = makeStyles(function () { return ({
    root: {
        minWidth: 'unset',
    },
    label: {
        textTransform: function (_a) {
            var textTransform = _a.textTransform;
            return textTransform;
        },
    },
}); });

export { useButtonStyles };
//# sourceMappingURL=ButtonStyles.js.map
